import {AuthProviderType} from "./providers";
import {SwitchAccountStore} from "../components/switch-account/switch-account-store";
import {OAuthStore} from "../components/auth/store";
import {clearMergeAccount} from "../components/link-account/useMergeAccount";
import {LinkAccountStore} from "../components/link-account/store";
import {AccountSubdomainStore} from "../components/auth/subdomain";

export const startLogin = (provider: AuthProviderType) => {
  LoginStore.setProvider(provider);
  SwitchAccountStore.clear();
  AccountSubdomainStore.clear();
}

export const getLoginProvider = (): AuthProviderType | undefined => {
  return LoginStore.getProvider() || undefined;
};

export const completeLogin = () => {
  LoginStore.clear();
  OAuthStore.clear();
  clearMergeAccount();
};

const key = "wakelet-login-provider";

export const LoginStore = {
  setProvider(authProvider: AuthProviderType): void {
    sessionStorage.setItem(key, authProvider)
  },
  getProvider(): AuthProviderType | null {
    const authProvider = sessionStorage.getItem(key)
    if (authProvider) {
      return authProvider as AuthProviderType
    }
    return null;
  },
  clear(): void {
    sessionStorage.removeItem(key);
  }
};
